import { cs } from '../../../lib/currency';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from '../../../components/ui/dialog';
import { Button } from '../../../components/ui/button';
import { Input } from '../../../components/ui/input';
import { Label } from '../../../components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../../../components/ui/select';
import { CreditCard, CheckCircle, Loader2 } from 'lucide-react';
import { PAYMENT_METHODS } from './constants';

export const BulkMarkPaidDialog = ({
  open, onOpenChange, selectedCount, tournament, method, setMethod,
  notes, setNotes, loading, onSubmit
}) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="max-w-lg" data-testid="bulk-mark-paid-dialog">
      <DialogHeader>
        <DialogTitle className="flex items-center gap-2"><CreditCard className="h-5 w-5 text-green-600" />Bulk Mark as Paid</DialogTitle>
        <DialogDescription>Mark {selectedCount} selected registration(s) as paid</DialogDescription>
      </DialogHeader>
      <div className="space-y-4 py-4">
        <div className="bg-green-50 border border-green-200 rounded-lg p-3">
          <p className="text-sm text-green-700"><strong>{selectedCount}</strong> registration(s) selected</p>
          <p className="text-sm text-green-600 mt-1">Amount per registration: <strong>{cs()}{tournament?.initial_payment_amount || 0}</strong></p>
          <p className="text-sm text-green-600">Total amount: <strong>{cs()}{(selectedCount * (tournament?.initial_payment_amount || 0)).toFixed(2)}</strong></p>
        </div>
        <div className="space-y-2">
          <Label>Payment Method</Label>
          <Select value={method} onValueChange={setMethod}>
            <SelectTrigger data-testid="bulk-payment-method-select"><SelectValue placeholder="Select payment method..." /></SelectTrigger>
            <SelectContent>
              {PAYMENT_METHODS.map(m => (<SelectItem key={m.value} value={m.value}>{m.label}</SelectItem>))}
            </SelectContent>
          </Select>
        </div>
        <div className="space-y-2">
          <Label>Notes (optional)</Label>
          <Input placeholder="e.g., Collected at tournament check-in" value={notes} onChange={(e) => setNotes(e.target.value)} data-testid="bulk-payment-notes" />
        </div>
      </div>
      <DialogFooter>
        <Button variant="outline" onClick={() => onOpenChange(false)} disabled={loading}>Cancel</Button>
        <Button onClick={onSubmit} disabled={loading || !method} className="bg-green-600 hover:bg-green-700" data-testid="bulk-mark-paid-submit">
          {loading ? (<><Loader2 className="h-4 w-4 mr-2 animate-spin" />Processing...</>) : (<><CheckCircle className="h-4 w-4 mr-2" />Mark {selectedCount} as Paid</>)}
        </Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);
